import * as React from "react";
import Formik, { FieldArray as FormikFieldArray } from "formik";

import Grid from "../Hedron";
import { MultiSelect } from "../MultiSelect";
import { IFormMultiSelect } from ".";
import FieldError from "./FieldError";
import Label from "./Label";

/**
 * Wraps the MultiSelect component to be used with Formik.
 */
const FieldMultiSelect: React.ReactFCWithChildren<IFormMultiSelect> = ({
  loading = false,
  name,
  handleChange,
  handleMultiSelectChange,
  fieldLogic,
  disabled,
  label,
  options,
  placeholder = "Start typing...",
  validateOnChange = false,
  error,
  disabledOptions,
  values = [],
  handleSpecificSearch,
  debounceTime,
  singleSelection
}) => {
  return (
    <div>
      <FormikFieldArray
        name={name}
        validateOnChange={validateOnChange}
        render={(arrayHelpers: Formik.ArrayHelpers & Formik.FieldArrayRenderProps) => (
          <div
            style={{
              width: "100%",
              maxWidth: "400px"
            }}
          >
            <Grid.Box>
              <Label
                for={name}
                label={label}
              />
            </Grid.Box>

            <MultiSelect
              disabledOptions={disabledOptions}
              loading={loading}
              disabled={disabled}
              options={options}
              placeholder={placeholder}
              defaultValues={options.filter(option => values.some(defaultValue => defaultValue === option.value))}
              handleChange={(action: "add" | "remove", affectedItem, oldSelectedItems, downShiftState) => {
                if (affectedItem && disabledOptions?.includes(affectedItem.value)) {
                  return;
                }
                const currentItemValues: string[] = oldSelectedItems.map(oldSelectedItem => oldSelectedItem.value);

                if (affectedItem) {
                  if (action === "add") {
                    // dont allow selection of disabled options
                    if (disabledOptions?.includes(affectedItem.value)) {
                      return;
                    }

                    if (!arrayHelpers.form.values[ name ] || arrayHelpers.form.values[ name ].indexOf(affectedItem.value) === -1) {
                      arrayHelpers.unshift(affectedItem.value);
                    }

                    if (currentItemValues.indexOf(affectedItem.value) === -1) {
                      currentItemValues.unshift(affectedItem.value);
                    }
                  } else {
                    if (arrayHelpers.form.values[ name ] && arrayHelpers.form.values[ name ].indexOf(affectedItem.value) !== -1) {
                      arrayHelpers.remove(arrayHelpers.form.values[ name ].indexOf(affectedItem.value));
                    }

                    if (currentItemValues.indexOf(affectedItem.value) !== -1) {
                      currentItemValues.splice(currentItemValues.indexOf(affectedItem.value), 1);
                    }
                  }

                  if (fieldLogic) {
                    fieldLogic(affectedItem.value, currentItemValues);
                  }

                  if (handleMultiSelectChange && downShiftState) {
                    handleChange(downShiftState);
                    handleMultiSelectChange(downShiftState, currentItemValues);
                  }
                }
              }}
              handleSpecificSearch={handleSpecificSearch}
              debounceTime={debounceTime}
              singleSelection={singleSelection}
            />
          </div>
        )}
      />

      {error && (
        <Grid.Box>
          <FieldError>
            {error}
          </FieldError>
        </Grid.Box>
      )}
    </div>
  );
};

export default FieldMultiSelect;
